module.exports = __webpack_public_path__ + "static/img/mail-game-2.c5a2be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mail-game-2.png
// module id = 8Xg4
// module chunks = 1